import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { boxStyles, propsMappingToStyles } from './styles.js';
import { BoxPropsMapping } from './props.js';
import styled from 'styled-components';
import { StyledContentText } from '../ContentText/styles.web.js';

var StyledBox = /*#__PURE__*/styled.div.withConfig({
  displayName: "Boxweb__StyledBox",
  componentId: "sc-1ornpyz-0"
})(["", "{color:", ";}", ";:hover{", "}"], StyledContentText, function (p) {
  return p.textColor;
}, boxStyles, function (p) {
  return p.hover ? propsMappingToStyles(BoxPropsMapping)(p.hover) : null;
});
var Box = function Box(_ref) {
  var boxRef = _ref.boxRef,
      asProp = _ref.as,
      tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ["boxRef", "as", "tag"]);

  // istanbul ignore next
  if (asProp) {
    console.warn('as prop is being deprecated in favor of tag, they work in similar fashion so just swap to tag instead of as');
  }

  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    "data-test": "elemental-Box",
    ref: boxRef // support as prop for backwards compatibility
    ,
    as: asProp || tag
  }, props));
};

export { Box, StyledBox };
